<template>
    <div>
        <b-row class="pb-2">
            <b-col class="flex flex-row">
                <app-detalhe titulo="Vigência" :xl="xl">
                    <strong >{{ pleito.vigencia }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Status" :xl="xl">
                    <app-status
                        :status="pleito.statusDescricao.toUpperCase()"
                    ></app-status>
                </app-detalhe>
                <app-detalhe titulo="CNPJ" :xl="xl">
                    <strong >{{ pleito.cnpj }}</strong>
                </app-detalhe>
                <app-detalhe class="text-nowrap" titulo="Proponente" :xl="xl">
                    <strong >{{ pleito.nomeProponente }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Nome do Projeto/Pleito" :xl="xl">
                    <strong >{{ pleito.descritivo }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Público Alvo" :xl="xl">
                    <strong >{{ pleito.publicoAlvo }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Objetivos" :xl="xl">
                    <strong >{{ pleito.objetivos }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Vínculo estratégia SEBRAE" :xl="xl">
                    <strong >{{ pleito.vinculoEstrategiaSebrae }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Justificativa da Proposição" :xl="xl">
                    <strong >{{ pleito.justificativaProposicao }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Foco estratégico para projetos de atendimento ou especificação de demanda" :xl="xl">
                    <strong >{{ pleito.focoEstrategico }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Resultado esperados" :xl="xl">
                    <strong >{{ pleito.resultadoEsperado }}</strong>
                </app-detalhe>
            </b-col>
            <b-col class="flex flex-row">
                <app-detalhe titulo="Fontes de recursos" :xl="xl">
                    <strong >{{ pleito.fontesDeRecursos }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Propriedade" :xl="xl">
                    <strong >{{ pleito.propriedade }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Justificativa de utilização da Conta Corrente" :xl="xl">
                    <strong >{{ pleito.justificativaUtilizacaoContaCorrente }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Bens produzidos" :xl="xl">
                    <strong >{{ pleito.bensProduzidos }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Produção destes bens" :xl="xl"> 
                    <strong >{{ pleito.producaoDestesBens }}</strong>
                </app-detalhe>
                <app-detalhe titulo="UF" :xl="xl">
                    <strong >{{ pleito.uf }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Cidade" :xl="xl"> 
                    <strong >{{ pleito.cidade }}</strong>
                </app-detalhe>
                <app-detalhe titulo="CEP" :xl="xl">
                    <strong >{{ pleito.cep }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Endereço" :xl="xl">
                    <strong >{{ pleito.endereco }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Numero" :xl="xl">
                    <strong >{{ pleito.numero }}</strong>
                </app-detalhe>
                 <app-detalhe titulo="Complemento" :xl="xl">
                    <strong >{{ pleito.complemento }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Telefone" :xl="xl">
                    <strong >{{ pleito.telefone }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Gestor" :xl="xl">
                    <strong >{{ pleito.nomeGestor }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Email do Gestor" :xl="xl">
                    <strong >{{ pleito.emailGestor }}</strong>
                </app-detalhe>
            </b-col>
        </b-row>
        <b-row>
            
        </b-row>
    </div>
</template>

<script>
export default {
    props: {
        pleito: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            xl: 2,
        }
    }
}
</script>
